// import { showSuccess, showError } from "utils/notifications";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";



// console.log("user")

// // ---------------- Helper: Detect "Action" column ----------------
// const isActionColumn = (col) => {
//   const name = (col?.Header || col?.header || col?.id || col?.accessor || "")
//     .toString()
//     .toLowerCase();
//   return name === "action" || name === "actions";
// };

// // ---------------- Helper: Detect "Image" column ----------------
// const isImageColumn = (col) => {
//   const name = (col?.Header || col?.header || col?.id || col?.accessor || "")
//     .toString()
//     .toLowerCase();
//   return (
//     name === "image" ||
//     name === "images" ||
//     name === "photo" ||
//     name === "picture"
//   );
// };

// // ---------------- Helper: Extract image URL from cell value ----------------
// const extractImageUrl = (value) => {
//   // If it's already a string URL
//   if (
//     typeof value === "string" &&
//     (value.startsWith("http") || value.startsWith("/"))
//   ) {
//     return value;
//   }

//   // If it's a React element with img tag
//   if (typeof value === "object" && value?.props) {
//     // Direct img element
//     if (value.type === "img" && value.props.src) {
//       return value.props.src;
//     }

//     // Check children for img
//     const children = value.props.children;
//     if (children?.type === "img" && children.props?.src) {
//       return children.props.src;
//     }

//     // Array of children
//     if (Array.isArray(children)) {
//       for (const child of children) {
//         if (child?.type === "img" && child.props?.src) {
//           return child.props.src;
//         }
//       }
//     }
//   }

//   return null;
// };

// // ---------------- Helper: Extract text from cell value ----------------
// const extractText = (value) => {
//   if (value === null || value === undefined) return "";

//   if (typeof value === "string" || typeof value === "number") {
//     return String(value);
//   }

//   if (typeof value === "boolean") {
//     return value ? "Yes" : "No";
//   }

//   // If it's an array
//   if (Array.isArray(value)) {
//     return value.map(extractText).join(" ");
//   }

//   // If it's a React element
//   if (typeof value === "object" && value?.props) {
//     return extractText(value.props.children);
//   }

//   // If it's a plain object
//   if (typeof value === "object") {
//     // Try common text keys
//     const keys = ["name", "label", "title", "value", "text"];
//     for (let key of keys) {
//       if (value[key]) {
//         return extractText(value[key]);
//       }
//     }

//     // Fallback to JSON
//     try {
//       return JSON.stringify(value);
//     } catch (e) {
//       return String(value);
//     }
//   }

//   return String(value);
// };

// // ---------------- Helper: Extract text from header (handles JSX, functions, strings) ----------------
// const extractHeaderText = (header) => {
//   if (typeof header === "string" || typeof header === "number")
//     return String(header);

//   if (typeof header === "object" && header?.props?.children) {
//     const children = header.props.children;
//     if (typeof children === "string" || typeof children === "number")
//       return String(children);
//     if (Array.isArray(children)) return children.map(extractText).join(" ");
//   }

//   if (typeof header === "function") return extractHeaderText(header());

//   return "";
// };

// // ---------------- Helper: Load image as base64 ----------------
// const loadImageAsBase64 = (url) => {
//   return new Promise((resolve) => {
//     const img = new Image();
//     img.crossOrigin = "Anonymous";

//     img.onload = () => {
//       try {
//         const canvas = document.createElement("canvas");
//         canvas.width = img.width;
//         canvas.height = img.height;
//         const ctx = canvas.getContext("2d");
//         ctx.drawImage(img, 0, 0);
//         const dataURL = canvas.toDataURL("image/jpeg");
//         resolve(dataURL);
//       } catch (e) {
//         console.error("Failed to convert image:", e);
//         resolve(null);
//       }
//     };

//     img.onerror = () => {
//       console.error("Failed to load image:", url);
//       resolve(null);
//     };

//     img.src = url;
//   });
// };

// // ---------------- PDF Export ----------------
// export const exportPDF = async ({
//   rows,
//   columns,
//   prepareRow,
//   fileName = "table-data",
//   user
// }) => {
//   if (!rows.length) return showError("No data to export!");

//   // Professional Color Palette
//   const colors = {
//     primary: [37, 99, 235],     // Professional Blue
//     secondary: [30, 64, 175],   // Dark Blue
//     accent: [59, 130, 246],     // Light Blue
//     text: [31, 41, 55],         // Dark Grey
//     muted: [107, 114, 128],     // Muted Grey
//     border: [229, 231, 235],    // Light Border
//     bg: [249, 250, 251],        // Subtle Background
//   };

//   const reportDate = new Date().toLocaleString("en-GB", {
//     day: "numeric",
//     month: "short",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//   });

//   // Filter out action columns
//   const filteredColumns = columns.filter((col) => !isActionColumn(col));

//   // Track which columns are images
//   const imageColumnIndices = filteredColumns
//     .map((col, idx) => (isImageColumn(col) ? idx : -1))
//     .filter((idx) => idx !== -1);

//   // Extract headers
//   const headers = filteredColumns.map((col) => {
//     const headerText = extractHeaderText(col.Header || col.header);
//     return headerText || col.accessor || col.id || "Column";
//   });

//   // Extract body data
//   const bodyData = [];
//   const imageData = [];
//   for (const row of rows) {
//     prepareRow(row);
//     const cells = row.getVisibleCells?.() || [];
//     const filteredCells = cells.filter((cell) => !isActionColumn(cell.column));

//     const rowData = [];
//     const rowImages = {};
//     filteredCells.forEach((cell, idx) => {
//       const value = cell.getValue();
//       if (imageColumnIndices.includes(idx)) {
//         const imageUrl = extractImageUrl(value);
//         if (imageUrl) {
//           rowImages[idx] = imageUrl;
//           rowData.push("");
//         } else {
//           rowData.push(extractText(value));
//         }
//       } else {
//         rowData.push(extractText(value));
//       }
//     });
//     bodyData.push(rowData);
//     imageData.push(rowImages);
//   }

//   // Preload images
//   const loadedImages = {};
//   for (let rowIdx = 0; rowIdx < imageData.length; rowIdx++) {
//     const rowImgs = imageData[rowIdx];
//     for (const colIdx in rowImgs) {
//       const imageUrl = rowImgs[colIdx];
//       if (imageUrl && !loadedImages[imageUrl]) {
//         const base64 = await loadImageAsBase64(imageUrl);
//         if (base64) loadedImages[imageUrl] = base64;
//       }
//     }
//   }

//   const doc = new jsPDF({ orientation: "landscape" });

//   const title = fileName
//     .replace(/-/g, " ")
//     .replace(/\b\w/g, (l) => l.toUpperCase());

//   autoTable(doc, {
//     head: [headers],
//     body: bodyData,
//     startY: 40,
//     margin: { top: 40, left: 14, right: 14, bottom: 20 },
//     styles: {
//       fontSize: 8.5,
//       cellPadding: 4,
//       overflow: "linebreak",
//       halign: "left",
//       minCellHeight: 12,
//       textColor: colors.text,
//       lineColor: colors.border,
//       lineWidth: 0.1,
//     },
//     headStyles: {
//       fillColor: colors.primary,
//       textColor: [255, 255, 255],
//       fontStyle: "bold",
//       fontSize: 9.5,
//       halign: "left",
//       cellPadding: 5,
//     },
//     alternateRowStyles: {
//       fillColor: colors.bg,
//     },
//     theme: "grid",
//     didDrawPage: (data) => {
//       // Branding Header
//       doc.setFontSize(22);
//       doc.setTextColor(colors.primary[0], colors.primary[1], colors.primary[2]);
//       doc.setFont("helvetica", "bold");
//       doc.text(`${user.site_text}`, 14, 20);

//       doc.setFontSize(10);
//       doc.setTextColor(colors.muted[0], colors.muted[1], colors.muted[2]);
//       doc.setFont("helvetica", "normal");
//       doc.text("Premium Property Management System", 14, 26);

//       // Horizontal Divider with Gradient-ish effect (simple lines)
//       doc.setDrawColor(colors.primary[0], colors.primary[1], colors.primary[2]);
//       doc.setLineWidth(0.8);
//       doc.line(14, 30, doc.internal.pageSize.width - 14, 30);

//       // Report Specific Info
//       doc.setFontSize(14);
//       doc.setTextColor(colors.text[0], colors.text[1], colors.text[2]);
//       doc.setFont("helvetica", "bold");
//       doc.text(`${title} Report`, doc.internal.pageSize.width - 14, 20, {
//         align: "right",
//       });

//       doc.setFontSize(9);
//       doc.setTextColor(colors.muted[0], colors.muted[1], colors.muted[2]);
//       doc.setFont("helvetica", "normal");
//       doc.text(`Generated on: ${reportDate}`, doc.internal.pageSize.width - 14, 26, {
//         align: "right",
//       });

//       // Footer
//       const pageCount = doc.internal.getNumberOfPages();
//       doc.setFontSize(8.5);
//       doc.setTextColor(colors.muted[0], colors.muted[1], colors.muted[2]);
//       const pageWidth = doc.internal.pageSize.width;
//       const pageHeight = doc.internal.pageSize.height;

//       doc.setDrawColor(colors.border[0], colors.border[1], colors.border[2]);
//       doc.setLineWidth(0.3);
//       doc.line(14, pageHeight - 15, pageWidth - 14, pageHeight - 15);

//       doc.text(`${user.site_text} - Software Solution by PixelWibes`, 14, pageHeight - 10);
//       doc.text(
//         `Page ${data.pageNumber} of ${pageCount}`,
//         pageWidth - 14,
//         pageHeight - 10,
//         { align: "right" }
//       );
//     },
//     didDrawCell: (data) => {
//       // Draw images centrally in rows
//       if (data.section === "body" && imageColumnIndices.includes(data.column.index)) {
//         const rowIndex = data.row.index;
//         const colIndex = data.column.index;
//         if (imageData[rowIndex] && imageData[rowIndex][colIndex]) {
//           const imageUrl = imageData[rowIndex][colIndex];
//           const base64Image = loadedImages[imageUrl];
//           if (base64Image) {
//             const cellWidth = data.cell.width;
//             const cellHeight = data.cell.height;
//             const imgSize = Math.min(cellWidth - 4, cellHeight - 4, 10);
//             doc.addImage(
//               base64Image,
//               "JPEG",
//               data.cell.x + (cellWidth - imgSize) / 2,
//               data.cell.y + (cellHeight - imgSize) / 2,
//               imgSize,
//               imgSize
//             );
//           }
//         }
//       }
//     },
//   });

//   doc.save(fileName + ".pdf");
//   showSuccess("PDF exported successfully!");
// };


// // ---------------- CSV Export ----------------
// export const exportCSV = ({
//   rows,
//   columns,
//   prepareRow,
//   fileName = "table-data.csv",
// }) => {
//   if (!rows.length) return showError("No data to export!");

//   const filteredColumns = columns.filter((col) => !isActionColumn(col));
//   const headers = filteredColumns
//     .map((col) => {
//       const headerText =
//         extractHeaderText(col.Header || col.header) ||
//         col.accessor ||
//         col.id ||
//         "Column";
//       return `"${headerText}"`;
//     })
//     .join(",");

//   const csvRows = rows.map((row) => {
//     prepareRow(row);
//     const cells = row.getVisibleCells?.() || [];
//     return cells
//       .filter((cell) => !isActionColumn(cell.column))
//       .map((cell) => {
//         const col = cell.column;
//         const value = cell.getValue();

//         // For image columns, export the URL
//         if (isImageColumn(col)) {
//           const imageUrl = extractImageUrl(value);
//           return `"${imageUrl || extractText(value)}"`;
//         }

//         return `"${extractText(value)}"`;
//       })
//       .join(",");
//   });

//   const csvContent = [headers, ...csvRows].join("\n");
//   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//   const url = URL.createObjectURL(blob);

//   const link = document.createElement("a");
//   link.href = url;
//   link.setAttribute("download", fileName);
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);

//   showSuccess("CSV exported successfully!");
// };

// // ---------------- Copy Table ----------------
// export const copyTable = ({ rows, columns, prepareRow }) => {
//   if (!rows.length) return showError("No data to copy!");

//   const filteredColumns = columns.filter((col) => !isActionColumn(col));
//   const headers = filteredColumns
//     .map(
//       (col) =>
//         extractHeaderText(col.Header || col.header) ||
//         col.accessor ||
//         col.id ||
//         "Column",
//     )
//     .join("\t");

//   const copiedRows = rows.map((row) => {
//     prepareRow(row);
//     const cells = row.getVisibleCells?.() || [];
//     return cells
//       .filter((cell) => !isActionColumn(cell.column))
//       .map((cell) => {
//         const col = cell.column;
//         const value = cell.getValue();

//         // For image columns, copy the URL
//         if (isImageColumn(col)) {
//           const imageUrl = extractImageUrl(value);
//           return imageUrl || extractText(value);
//         }

//         return extractText(value);
//       })
//       .join("\t");
//   });

//   const textToCopy = [headers, ...copiedRows].join("\n");
//   navigator.clipboard.writeText(textToCopy).then(
//     () => showSuccess("Table copied to clipboard!"),
//     () => showError("Failed to copy table."),
//   );
// };

// // ---------------- Print Table ----------------
// export const printTable = ({ rows, columns, prepareRow, fileName, user = "HHH" }) => {

//   if (!rows.length) return showError("No data to print!");

//   const filteredColumns = columns.filter((col) => !isActionColumn(col));
//   const reportDate = new Date().toLocaleString("en-GB", {
//     day: "numeric",
//     month: "short",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//   });

//   const headers = filteredColumns
//     .map((col) => {
//       const headerText =
//         extractHeaderText(col.Header || col.header) ||
//         col.accessor ||
//         col.id ||
//         "Column";
//       return `<th>${headerText}</th>`;
//     })
//     .join("");

//   let tableRows = "";
//   rows.forEach((row, index) => {
//     prepareRow(row);
//     const cells = row.getVisibleCells?.() || [];
//     const rowData = cells
//       .filter((cell) => !isActionColumn(cell.column))
//       .map((cell) => {
//         const col = cell.column;
//         const value = cell.getValue();
//         const textValue = extractText(value);

//         // For image columns, render actual image tag
//         if (isImageColumn(col)) {
//           const imageUrl = extractImageUrl(value);
//           if (imageUrl) {
//             return `<td><img src="${imageUrl}" /></td>`;
//           }
//         }

//         // Style status badges if applicable
//         if (
//           col.id === "status" ||
//           col.accessor === "status" ||
//           String(col.Header).toLowerCase().includes("status")
//         ) {
//           const statusClass = textValue.toLowerCase();
//           return `<td><span class="status-badge ${statusClass}">${textValue}</span></td>`;
//         }

//         return `<td>${textValue}</td>`;
//       })
//       .join("");
//     tableRows += `<tr>${rowData}</tr>`;
//   });

//   const printWindow = window.open("", "", "width=1100,height=850");
//   if (printWindow) {
//     printWindow.document.write(`
//       <!DOCTYPE html>
//       <html>
//         <head>
//           <title>${user.site_text} - ${fileName}</title>
//           <style>
//             :root {
//               --primary: #2563eb;
//               --primary-light: #eff6ff;
//               --text-main: #111827;
//               --text-muted: #6b7280;
//               --border-color: #e5e7eb;
//               --bg-muted: #f9fafb;
//               --success-bg: #dcfce7;
//               --success-text: #166534;
//               --error-bg: #fee2e2;
//               --error-text: #991b1b;
//               --warning-bg: #fef9c3;
//               --warning-text: #854d0e;
//             }

//             @page {
//               size: landscape;
//               margin: 12mm;
//             }

//             body {
//               font-family: 'Inter', system-ui, -apple-system, sans-serif;
//               color: var(--text-main);
//               line-height: 1.5;
//               padding: 0;
//               margin: 0;
//               -webkit-print-color-adjust: exact;
//               print-color-adjust: exact;
//             }

//             .report-container {
//               max-width: 100%;
//             }

//             /* Header Branding */
//             .header {
//               display: flex;
//               justify-content: space-between;
//               align-items: center;
//               border-bottom: 2.5px solid var(--primary);
//               padding-bottom: 12px;
//               margin-bottom: 25px;
//             }

//             .brand-section h1 {
//               margin: 0;
//               color: var(--primary);
//               font-size: 26px;
//               font-weight: 800;
//               letter-spacing: -0.5px;
//               text-transform: uppercase;
//             }

//             .brand-section p {
//               margin: 2px 0 0 0;
//               font-size: 13px;
//               color: var(--text-muted);
//               font-weight: 500;
//             }

//             .report-meta {
//               text-align: right;
//             }

//             .report-meta h2 {
//               margin: 0;
//               font-size: 18px;
//               color: var(--text-main);
//               font-weight: 700;
//             }

//             .report-meta p {
//               margin: 4px 0 0 0;
//               font-size: 11px;
//               color: var(--text-muted);
//             }

//             /* Table Styling */
//             table {
//               width: 100%;
//               border-collapse: collapse;
//             }

//             th {
//               background-color: var(--bg-muted);
//               color: var(--text-main);
//               font-weight: 700;
//               font-size: 11px;
//               text-transform: uppercase;
//               letter-spacing: 0.05em;
//               padding: 12px 10px;
//               border-bottom: 1.5px solid var(--border-color);
//               text-align: left;
//             }

//             td {
//               padding: 10px;
//               font-size: 12.5px;
//               border-bottom: 1px solid var(--border-color);
//               vertical-align: middle;
//             }

//             tr:nth-child(even) {
//               background-color: var(--bg-muted);
//             }

//             img {
//               width: 42px;
//               height: 42px;
//               object-fit: cover;
//               border-radius: 6px;
//               border: 1px solid var(--border-color);
//             }

//             /* Status Badges */
//             .status-badge {
//               padding: 4px 12px;
//               border-radius: 99px;
//               font-size: 10.5px;
//               font-weight: 700;
//               text-transform: capitalize;
//               display: inline-block;
//             }


//             .status-badge.approved, .status-badge.active, .status-badge.paid, .status-badge.success {
//               background: var(--success-bg);
//               color: var(--success-text);
//             }

//             .status-badge.cancelled, .status-badge.inactive, .status-badge.failed, .status-badge.unpaid {
//               background: var(--error-bg);
//               color: var(--error-text);
//             }

//             .status-badge.pending, .status-badge.generated, .status-badge.waiting {
//               background: var(--warning-bg);
//               color: var(--warning-text);
//             }

//             /* Footer */
//             .footer {
//               margin-top: 30px;
//               padding-top: 10px;
//               border-top: 1px solid var(--border-color);
//               display: flex;
//               justify-content: space-between;
//               font-size: 11px;
//               color: var(--text-muted);
//             }

//             @media print {
//               .no-print { display: none; }
//               body { padding: 5mm; }
//               tr { page-break-inside: avoid; }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="report-container">
//             <header class="header">
//               <div class="brand-section">
//                 <h1>${user.site_text}</h1>
//                 <p>Premium Property Management System</p>
//               </div>
//               <div class="report-meta">
//                 <h2>${fileName.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())} Report</h2>
//                 <p>Generated on: ${reportDate}</p>
//               </div>
//             </header>

//             <table>
//               <thead>
//                 <tr>${headers}</tr>
//               </thead>
//               <tbody>
//                 ${tableRows}
//               </tbody>
//             </table>

//             <footer class="footer">
//               <span>${user.site_text}</span>
//               <span>Confidential & Internal Use Only</span>
//               <span class="page-number">Page 1 of 1</span>
//             </footer>
//           </div>
//           <script>
//             window.onload = function() {
//               window.print();
//               // window.close(); // Optional: Close window after printing
//             }
//           </script>
//         </body>
//       </html>
//     `);
//     printWindow.document.close();
//   } else {
//     showError("Unable to open print window. Please check your popup blocker.");
//   }
// };










import { showSuccess, showError } from "utils/notifications";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// ---------------- Helper: Detect "Action" column ----------------
const isActionColumn = (col) => {
  const name = (col?.Header || col?.header || col?.id || col?.accessor || "")
    .toString()
    .toLowerCase();
  return name === "action" || name === "actions";
};

// ---------------- Helper: Detect "Image" column ----------------
const isImageColumn = (col) => {
  const name = (col?.Header || col?.header || col?.id || col?.accessor || "")
    .toString()
    .toLowerCase();
  return (
    name === "image" ||
    name === "images" ||
    name === "photo" ||
    name === "picture"
  );
};

// ---------------- Helper: Extract image URL from cell value ----------------
const extractImageUrl = (value) => {
  if (
    typeof value === "string" &&
    (value.startsWith("http") || value.startsWith("/"))
  ) {
    return value;
  }

  if (typeof value === "object" && value?.props) {
    if (value.type === "img" && value.props.src) {
      return value.props.src;
    }

    const children = value.props.children;
    if (children?.type === "img" && children.props?.src) {
      return children.props.src;
    }

    if (Array.isArray(children)) {
      for (const child of children) {
        if (child?.type === "img" && child.props?.src) {
          return child.props.src;
        }
      }
    }
  }

  return null;
};

// ---------------- Helper: Extract text from cell value ----------------
const extractText = (value) => {
  if (value === null || value === undefined) return "";

  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }

  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }

  if (Array.isArray(value)) {
    return value.map(extractText).join(" ");
  }

  if (typeof value === "object" && value?.props) {
    return extractText(value.props.children);
  }

  if (typeof value === "object") {
    const keys = ["name", "label", "title", "value", "text"];
    for (let key of keys) {
      if (value[key]) {
        return extractText(value[key]);
      }
    }

    try {
      return JSON.stringify(value);
    } catch (e) {
      return String(value);
    }
  }

  return String(value);
};

// ---------------- Helper: Extract text from header (handles JSX, functions, strings) ----------------
const extractHeaderText = (header) => {
  if (typeof header === "string" || typeof header === "number")
    return String(header);

  if (typeof header === "object" && header?.props?.children) {
    const children = header.props.children;
    if (typeof children === "string" || typeof children === "number")
      return String(children);
    if (Array.isArray(children)) return children.map(extractText).join(" ");
  }

  if (typeof header === "function") return extractHeaderText(header());

  return "";
};

// ---------------- Helper: Load an image (URL) as base64 ----------------
const loadImageAsBase64 = (url) => {
  return new Promise((resolve) => {
    if (!url) return resolve(null);

    const img = new Image();
    img.crossOrigin = "Anonymous";

    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      } catch (e) {
        console.error("Failed to convert image:", e);
        resolve(null);
      }
    };

    img.onerror = () => {
      console.error("Failed to load image:", url);
      resolve(null);
    };

    img.src = url;
  });
};

// ---------------- Corporate design tokens ----------------
const THEME = {
  navy: [15, 23, 42], // slate-900 — headline text / primary accent
  slate: [51, 65, 85], // slate-700 — secondary text
  muted: [100, 116, 139], // slate-500 — captions / meta
  border: [226, 232, 240], // slate-200 — hairlines / table borders
  headerBg: [241, 245, 249], // slate-100 — table header background
  rowAlt: [248, 250, 252], // slate-50 — zebra striping
  white: [255, 255, 255],
};

const toTitleCase = (str) =>
  str.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

// ---------------- PDF Export ----------------
export const exportPDF = async ({
  rows,
  columns,
  prepareRow,
  fileName = "table-data",
  user,
  generatedBy,
  logoUrl,
  watermarkText = "PixelWibes",
  footerRow,
}) => {
  if (!rows.length) return showError("No data to export!");

  const reportDate = new Date().toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  const filteredColumns = columns.filter((col) => !isActionColumn(col));

  // Track which columns are images
  const imageColumnIndices = filteredColumns
    .map((col, idx) => (isImageColumn(col) ? idx : -1))
    .filter((idx) => idx !== -1);

  // Extract headers
  const headers = filteredColumns.map((col) => {
    const headerText = extractHeaderText(col.Header || col.header);
    return headerText || col.accessor || col.id || "Column";
  });

  // Extract body data
  const bodyData = [];
  const imageData = [];
  for (const row of rows) {
    prepareRow(row);
    const cells = row.getVisibleCells?.() || [];
    const filteredCells = cells.filter((cell) => !isActionColumn(cell.column));

    const rowData = [];
    const rowImages = {};
    filteredCells.forEach((cell, idx) => {
      const value = cell.getValue();
      if (imageColumnIndices.includes(idx)) {
        const imageUrl = extractImageUrl(value);
        if (imageUrl) {
          rowImages[idx] = imageUrl;
          rowData.push("");
        } else {
          rowData.push(extractText(value));
        }
      } else {
        rowData.push(extractText(value));
      }
    });
    bodyData.push(rowData);
    imageData.push(rowImages);
  }

  // Preload row images
  const loadedImages = {};
  for (let rowIdx = 0; rowIdx < imageData.length; rowIdx++) {
    const rowImgs = imageData[rowIdx];
    for (const colIdx in rowImgs) {
      const imageUrl = rowImgs[colIdx];
      if (imageUrl && !loadedImages[imageUrl]) {
        const base64 = await loadImageAsBase64(imageUrl);
        if (base64) loadedImages[imageUrl] = base64;
      }
    }
  }

  // Preload logo (optional — falls back gracefully to a text wordmark)
  const resolvedLogoUrl = logoUrl || user?.logo || user?.site_logo || null;
  const logoBase64 = resolvedLogoUrl
    ? await loadImageAsBase64(resolvedLogoUrl)
    : null;

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 14;

  const title = toTitleCase(fileName);
  const totalRecords = rows.length;
  const preparedBy = generatedBy || user?.name || user?.full_name || "System";

  const HEADER_BOTTOM_Y = 42; // where the divider/table start sits

  autoTable(doc, {
    head: [headers],
    body: bodyData,
    foot: footerRow
      ? [
          filteredColumns.map((col) => {
            const key = col.accessor || col.id || col.Header || "";
            return extractText(footerRow[key] ?? "");
          }),
        ]
      : undefined,
    startY: HEADER_BOTTOM_Y + 6,
    margin: { top: HEADER_BOTTOM_Y + 6, left: margin, right: margin, bottom: 20 },
    footStyles: {
      fillColor: THEME.headerBg,
      textColor: THEME.navy,
      fontStyle: "bold",
      fontSize: 8.5,
      halign: "left",
      cellPadding: 5,
      lineColor: THEME.border,
      lineWidth: 0.15,
    },
    styles: {
      fontSize: 8.5,
      cellPadding: 4,
      overflow: "linebreak",
      halign: "left",
      minCellHeight: 12,
      textColor: THEME.slate,
      lineColor: THEME.border,
      lineWidth: 0.15,
      valign: "middle",
    },
    headStyles: {
      fillColor: THEME.headerBg,
      textColor: THEME.navy,
      fontStyle: "bold",
      fontSize: 8.5,
      halign: "left",
      cellPadding: 5,
      lineColor: THEME.border,
      lineWidth: 0.15,
    },
    bodyStyles: {
      lineColor: THEME.border,
    },
    alternateRowStyles: {
      fillColor: THEME.rowAlt,
    },
    theme: "grid",

    // ---------------- Header / footer / watermark, drawn on every page ----------------
    didDrawPage: (data) => {
      // Watermark (drawn first so table/header sit on top)
      if (watermarkText) {
        try {
          doc.saveGraphicsState();
          doc.setGState(new doc.GState({ opacity: 0.06 }));
          doc.setFont("helvetica", "bold");
          doc.setFontSize(66);
          doc.setTextColor(THEME.navy[0], THEME.navy[1], THEME.navy[2]);
          doc.text(watermarkText, pageWidth / 2, pageHeight / 2, {
            align: "center",
            angle: 35,
          });
          doc.restoreGraphicsState();
        } catch (e) {
          // GState plugin unavailable — skip watermark silently
        }
      }

      // ---- Left: logo + company name ----
      let brandX = margin;
      const brandTop = 9;
      const logoSize = 16;

      if (logoBase64) {
        try {
          doc.addImage(logoBase64, brandX, brandTop, logoSize, logoSize);
          brandX += logoSize + 5;
        } catch (e) {
          // ignore malformed logo, fall back to wordmark only
        }
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(17);
      doc.setTextColor(THEME.navy[0], THEME.navy[1], THEME.navy[2]);
      doc.text(`${user?.site_text || "Company"}`, brandX, brandTop + 8);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(THEME.muted[0], THEME.muted[1], THEME.muted[2]);
      doc.text("Premium Property Management System", brandX, brandTop + 13);

      // ---- Right: report title + info card ----
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.setTextColor(THEME.navy[0], THEME.navy[1], THEME.navy[2]);
      doc.text(`${title} Report`, pageWidth - margin, brandTop + 5, {
        align: "right",
      });

      const cardWidth = 92;
      const cardHeight = 14;
      const cardX = pageWidth - margin - cardWidth;
      const cardY = brandTop + 8;

      doc.setFillColor(THEME.rowAlt[0], THEME.rowAlt[1], THEME.rowAlt[2]);
      doc.setDrawColor(THEME.border[0], THEME.border[1], THEME.border[2]);
      doc.setLineWidth(0.2);
      doc.roundedRect(cardX, cardY, cardWidth, cardHeight, 1.5, 1.5, "FD");

      const infoCols = [
        { label: "GENERATED ON", value: reportDate },
        { label: "GENERATED BY", value: preparedBy },
        { label: "TOTAL RECORDS", value: String(totalRecords) },
      ];
      const colWidth = cardWidth / infoCols.length;

      infoCols.forEach((col, i) => {
        const colX = cardX + i * colWidth + colWidth / 2;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(6);
        doc.setTextColor(THEME.muted[0], THEME.muted[1], THEME.muted[2]);
        doc.text(col.label, colX, cardY + 5.5, { align: "center" });

        doc.setFont("helvetica", "bold");
        doc.setFontSize(8.5);
        doc.setTextColor(THEME.navy[0], THEME.navy[1], THEME.navy[2]);
        doc.text(col.value, colX, cardY + 10.5, { align: "center" });

        if (i > 0) {
          doc.setDrawColor(THEME.border[0], THEME.border[1], THEME.border[2]);
          doc.setLineWidth(0.15);
          doc.line(
            cardX + i * colWidth,
            cardY + 2.5,
            cardX + i * colWidth,
            cardY + cardHeight - 2.5
          );
        }
      });

      // ---- Divider ----
      doc.setDrawColor(THEME.navy[0], THEME.navy[1], THEME.navy[2]);
      doc.setLineWidth(0.6);
      doc.line(margin, HEADER_BOTTOM_Y, pageWidth - margin, HEADER_BOTTOM_Y);

      // ---- Footer ----
      const pageCount = doc.internal.getNumberOfPages();
      doc.setDrawColor(THEME.border[0], THEME.border[1], THEME.border[2]);
      doc.setLineWidth(0.2);
      doc.line(margin, pageHeight - 14, pageWidth - margin, pageHeight - 14);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7.5);
      doc.setTextColor(THEME.muted[0], THEME.muted[1], THEME.muted[2]);
      doc.text(
        `${user?.site_text || "Company"} \u2014 Confidential & Internal Use Only`,
        margin,
        pageHeight - 9
      );
      doc.text(
        "Software Solution by PixelWibes",
        pageWidth / 2,
        pageHeight - 9,
        { align: "center" }
      );
      doc.text(
        `Page ${data.pageNumber} of ${pageCount}`,
        pageWidth - margin,
        pageHeight - 9,
        { align: "right" }
      );
    },

    // ---------------- Image cells ----------------
    didDrawCell: (data) => {
      if (data.section === "body" && imageColumnIndices.includes(data.column.index)) {
        const rowIndex = data.row.index;
        const colIndex = data.column.index;
        if (imageData[rowIndex] && imageData[rowIndex][colIndex]) {
          const imageUrl = imageData[rowIndex][colIndex];
          const base64Image = loadedImages[imageUrl];
          if (base64Image) {
            const cellWidth = data.cell.width;
            const cellHeight = data.cell.height;
            const imgSize = Math.min(cellWidth - 6, cellHeight - 6, 14);
            const imgX = data.cell.x + (cellWidth - imgSize) / 2;
            const imgY = data.cell.y + (cellHeight - imgSize) / 2;

            // Subtle rounded border frame around the thumbnail
            doc.setDrawColor(THEME.border[0], THEME.border[1], THEME.border[2]);
            doc.setLineWidth(0.15);
            doc.roundedRect(imgX - 0.5, imgY - 0.5, imgSize + 1, imgSize + 1, 1, 1, "S");

            doc.addImage(base64Image, "PNG", imgX, imgY, imgSize, imgSize);
          }
        }
      }
    },
  });

  doc.save(fileName + ".pdf");
  showSuccess("PDF exported successfully!");
};

// ---------------- CSV Export ----------------
export const exportCSV = ({
  rows,
  columns,
  prepareRow,
  fileName = "table-data.csv",
  user,
  footerRow,
}) => {
  if (!rows.length) return showError("No data to export!");

  const filteredColumns = columns.filter((col) => !isActionColumn(col));
  const headers = filteredColumns
    .map((col) => {
      const headerText =
        extractHeaderText(col.Header || col.header) ||
        col.accessor ||
        col.id ||
        "Column";
      return `"${headerText}"`;
    })
    .join(",");

  const csvRows = rows.map((row) => {
    prepareRow(row);
    const cells = row.getVisibleCells?.() || [];
    return cells
      .filter((cell) => !isActionColumn(cell.column))
      .map((cell) => {
        const col = cell.column;
        const value = cell.getValue();

        if (isImageColumn(col)) {
          const imageUrl = extractImageUrl(value);
          return `"${imageUrl || extractText(value)}"`;
        }

        return `"${extractText(value)}"`;
      })
      .join(",");
  });

  if (footerRow) {
    const footerCsv = filteredColumns
      .map((col) => {
        const key = col.accessor || col.id || col.Header || "";
        const val = footerRow[key] ?? "";
        return `"${extractText(val)}"`;
      })
      .join(",");
    csvRows.push(footerCsv);
  }

  const csvContent = [headers, ...csvRows].join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  showSuccess("CSV exported successfully!");
};

// ---------------- Copy Table ----------------
export const copyTable = ({ rows, columns, prepareRow, fileName, user, footerRow }) => {
  if (!rows.length) return showError("No data to copy!");

  const filteredColumns = columns.filter((col) => !isActionColumn(col));
  const headers = filteredColumns
    .map(
      (col) =>
        extractHeaderText(col.Header || col.header) ||
        col.accessor ||
        col.id ||
        "Column",
    )
    .join("\t");

  const copiedRows = rows.map((row) => {
    prepareRow(row);
    const cells = row.getVisibleCells?.() || [];
    return cells
      .filter((cell) => !isActionColumn(cell.column))
      .map((cell) => {
        const col = cell.column;
        const value = cell.getValue();

        if (isImageColumn(col)) {
          const imageUrl = extractImageUrl(value);
          return imageUrl || extractText(value);
        }

        return extractText(value);
      })
      .join("\t");
  });

  if (footerRow) {
    const footerText = filteredColumns
      .map((col) => {
        const key = col.accessor || col.id || col.Header || "";
        return extractText(footerRow[key] ?? "");
      })
      .join("\t");
    copiedRows.push(footerText);
  }

  const textToCopy = [headers, ...copiedRows].join("\n");
  navigator.clipboard.writeText(textToCopy).then(
    () => showSuccess("Table copied to clipboard!"),
    () => showError("Failed to copy table."),
  );
};

// ---------------- Print Table ----------------
export const printTable = ({ rows, columns, prepareRow, fileName, user = "HHH", footerRow }) => {

  if (!rows.length) return showError("No data to print!");

  const filteredColumns = columns.filter((col) => !isActionColumn(col));
  const reportDate = new Date().toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  const headers = filteredColumns
    .map((col) => {
      const headerText =
        extractHeaderText(col.Header || col.header) ||
        col.accessor ||
        col.id ||
        "Column";
      return `<th>${headerText}</th>`;
    })
    .join("");

  let tableRows = "";
  rows.forEach((row, index) => {
    prepareRow(row);
    const cells = row.getVisibleCells?.() || [];
    const rowData = cells
      .filter((cell) => !isActionColumn(cell.column))
      .map((cell) => {
        const col = cell.column;
        const value = cell.getValue();
        const textValue = extractText(value);

        if (isImageColumn(col)) {
          const imageUrl = extractImageUrl(value);
          if (imageUrl) {
            return `<td><img src="${imageUrl}" /></td>`;
          }
        }

        if (
          col.id === "status" ||
          col.accessor === "status" ||
          String(col.Header).toLowerCase().includes("status")
        ) {
          const statusClass = textValue.toLowerCase();
          return `<td><span class="status-badge ${statusClass}">${textValue}</span></td>`;
        }

        return `<td>${textValue}</td>`;
      })
      .join("");
    tableRows += `<tr>${rowData}</tr>`;
  });

  let footerHtml = "";
  if (footerRow) {
    const footerCells = filteredColumns
      .map((col) => {
        const key = col.accessor || col.id || col.Header || "";
        const val = footerRow[key] ?? "";
        return `<td style="font-weight:bold;">${extractText(val)}</td>`;
      })
      .join("");
    footerHtml = `<tfoot style="font-weight:bold;background:#f1f5f9;"><tr>${footerCells}</tr></tfoot>`;
  }

  const printWindow = window.open("", "", "width=1100,height=850");
  if (printWindow) {
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${user.site_text} - ${fileName}</title>
          <style>
            :root {
              --primary: #0f172a;
              --primary-light: #f1f5f9;
              --text-main: #1e293b;
              --text-muted: #64748b;
              --border-color: #e2e8f0;
              --bg-muted: #f8fafc;
              --success-bg: #dcfce7;
              --success-text: #166534;
              --error-bg: #fee2e2;
              --error-text: #991b1b;
              --warning-bg: #fef9c3;
              --warning-text: #854d0e;
            }

            @page {
              size: landscape;
              margin: 12mm;
            }

            body {
              font-family: 'Inter', system-ui, -apple-system, sans-serif;
              color: var(--text-main);
              line-height: 1.5;
              padding: 0;
              margin: 0;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            .report-container {
              max-width: 100%;
            }

            .header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 2.5px solid var(--primary);
              padding-bottom: 12px;
              margin-bottom: 25px;
            }

            .brand-section h1 {
              margin: 0;
              color: var(--primary);
              font-size: 26px;
              font-weight: 800;
              letter-spacing: -0.5px;
              text-transform: uppercase;
            }

            .brand-section p {
              margin: 2px 0 0 0;
              font-size: 13px;
              color: var(--text-muted);
              font-weight: 500;
            }

            .report-meta {
              text-align: right;
            }

            .report-meta h2 {
              margin: 0;
              font-size: 18px;
              color: var(--text-main);
              font-weight: 700;
            }

            .report-meta p {
              margin: 4px 0 0 0;
              font-size: 11px;
              color: var(--text-muted);
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            th {
              background-color: var(--bg-muted);
              color: var(--text-main);
              font-weight: 700;
              font-size: 11px;
              text-transform: uppercase;
              letter-spacing: 0.05em;
              padding: 12px 10px;
              border-bottom: 1.5px solid var(--border-color);
              text-align: left;
            }

            td {
              padding: 10px;
              font-size: 12.5px;
              border-bottom: 1px solid var(--border-color);
              vertical-align: middle;
            }

            tr:nth-child(even) {
              background-color: var(--bg-muted);
            }

            img {
              width: 42px;
              height: 42px;
              object-fit: cover;
              border-radius: 6px;
              border: 1px solid var(--border-color);
            }

            .status-badge {
              padding: 4px 12px;
              border-radius: 99px;
              font-size: 10.5px;
              font-weight: 700;
              text-transform: capitalize;
              display: inline-block;
            }

            .status-badge.approved, .status-badge.active, .status-badge.paid, .status-badge.success {
              background: var(--success-bg);
              color: var(--success-text);
            }

            .status-badge.cancelled, .status-badge.inactive, .status-badge.failed, .status-badge.unpaid {
              background: var(--error-bg);
              color: var(--error-text);
            }

            .status-badge.pending, .status-badge.generated, .status-badge.waiting {
              background: var(--warning-bg);
              color: var(--warning-text);
            }

            .footer {
              margin-top: 30px;
              padding-top: 10px;
              border-top: 1px solid var(--border-color);
              display: flex;
              justify-content: space-between;
              font-size: 11px;
              color: var(--text-muted);
            }

            @media print {
              .no-print { display: none; }
              body { padding: 5mm; }
              tr { page-break-inside: avoid; }
            }
          </style>
        </head>
        <body>
          <div class="report-container">
            <header class="header">
              <div class="brand-section">
                <h1>${user.site_text}</h1>
                <p>Premium Property Management System</p>
              </div>
              <div class="report-meta">
                <h2>${fileName.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())} Report</h2>
                <p>Generated on: ${reportDate}</p>
              </div>
            </header>

            <table>
              <thead>
                <tr>${headers}</tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
              ${footerHtml}
            </table>

            <footer class="footer">
              <span>${user.site_text}</span>
              <span>Confidential & Internal Use Only</span>
              <span class="page-number">Page 1 of 1</span>
            </footer>
          </div>
          <script>
            window.onload = function() {
              window.print();
              // window.close(); // Optional: Close window after printing
            }
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  } else {
    showError("Unable to open print window. Please check your popup blocker.");
  }
};